import React, { FC, PropsWithChildren } from "react";
import { createContext } from "shared/utils/context";
import { useUnreadSupportMessages } from "../hooks/useUnreadSupportMessages";
import { useDecrementUnreadMessagesMutation } from "../mutations/useDecrementUnreadMessagesMutation";
import { MainLayoutPageType } from "./types";

const [Provider, useMainLayoutPage] = createContext<MainLayoutPageType>({
  name: "MainLayoutContext",
  hookName: "useMainLayoutPage",
  providerName: "MainLayoutPageProvider",
});

const MainLayoutPageProvider: FC<PropsWithChildren> = ({ children }) => {
  const { mutate } = useDecrementUnreadMessagesMutation();
  const { data } = useUnreadSupportMessages();

  const decrementUnreadMessagesCount = (count: number) => {
    mutate({ decrementValue: count });
  };

  const value = {
    unreadTicketsMessagesCount: data || 0,
    decrementUnreadMessagesCount,
  };

  return <Provider value={value}>{children}</Provider>;
};

export { MainLayoutPageProvider, useMainLayoutPage };
